import ItemWiseSaleProfitLossList from "./ItemWiseSaleProfitLossList";
const ItemWiseSaleProfitLossRoutes = [
    {
        path: "/ItemWiseSaleProfitLoss/item-wise-sale-profit-loss-list",
        component: ItemWiseSaleProfitLossList,
        permission: "Permissions.Sales.ItemWiseSaleProfitLoss",
    },

];
export default ItemWiseSaleProfitLossRoutes;